import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ErrorBoundary } from "./components/ErrorBoundary";


function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <Suspense
            fallback={
              <div className="min-h-screen bg-white flex items-center justify-center px-6">
                <div className="text-gray-600 font-medium">Loading...</div>
              </div>
            }
          >
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
